import { createFileRoute, redirect } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { CreatePasswordPage } from "@/modules/auth";

const createPasswordSearchSchema = z.object({
  token: fallback(z.string(), "")
});

export const Route = createFileRoute("/auth/create-password")({
  component: () => (
    <>
      <DocumentTitle
        title="Create Password"
        description="Set up your LAMPU Seller Center account password."
      />
      <CreatePasswordPage />
    </>
  ),
  validateSearch: zodValidator(createPasswordSearchSchema),
  beforeLoad: ({ context, search }) => {
    if (!search.token) {
      throw redirect({
        to: "/auth/login"
      });
    }

    if (context.auth.isAuthenticated) {
      throw redirect({
        to: "/"
      });
    }
  }
});
